export const getCardDetailsParams = (props) => {
    return {
        event: props.event,
        hideGameState: props.hideGameState,
        handlers: props.handlers,
        dict: props.dict,
        showLeagueInEventCard: props.showLeagueInEventCard,
        markets: props.markets,
        isDesktop: props.isDesktop
    };
};
//# sourceMappingURL=getCardDetailsParams.js.map